import React from 'react'
// except product id list: 917, 744, 
// 235/65R17 Roadcruza: 917
// 265/50R20 Roadcruza: 744
// 265/60R18 Roadcruza: 1653

export default function ProductIcon3PMS({
    product
}) {
    if (!product) return null
    if (product.id === 917 || product.id === 744 || product.id === 1653) return null
    return (
        <>
            {(product.brands === 'RoadCruza' ||
                product.title?.toLowerCase()?.indexOf('roadcruza') !== -1 ||
                product.type_name === 'Winter Tires' ||
                product.type_name === 'All Weather Tires'
            ) && (
                    <img className='item-img-3pms' src="/3pms_icon.webp" alt="Three-Peak Mountain Snowflake" />
                )}
        </>
    )
}
